import PaymentCardCard from "./paymentCardCard.container";

export default PaymentCardCard;
